import FormModule from './form.module';
import Components from './components';

import UlForm from './form.component.vue';
import UlFormGenerator from './generator.component.vue';
import UlFormItem from './item/item.component.vue';
import UlFormItemBtn from './item/btn.component.vue';
import UlFormItemSpace from './item/space.component.vue';

import UlFormBtnCancel from './btn/cancel.component.vue';
import UlFormBtnDefault from './btn/default.component.vue';
import UlFormBtnPrimary from './btn/primary.component.vue';
import UlFormBtnSubmit from './btn/submit.component.vue';

export default FormModule;

export const FormVue = {
  install(Vue) {
    Vue.use(Components);
    Vue.component('UlForm', UlForm);
    Vue.component('UlFormGenerator', UlFormGenerator);
    Vue.component('UlFormItem', UlFormItem);
    Vue.component('UlFormItemBtn', UlFormItemBtn);
    Vue.component('UlFormItemSpace', UlFormItemSpace);

    Vue.component('UlFormBtnCancel', UlFormBtnCancel);
    Vue.component('UlFormBtnDefault', UlFormBtnDefault);
    Vue.component('UlFormBtnPrimary', UlFormBtnPrimary);
    Vue.component('UlFormBtnSubmit', UlFormBtnSubmit);
  },
  FormModule,
};
